/**
 * 第三方登录 / 绑定失败之后，better-auth 会把人送回我们指定的页面，
 * 地址后面带一个 `?error=<错误码>`。这里把错误码翻成人话。
 *
 * ════════════════════════════════════════════════════════
 * 为什么值得单独做
 * ════════════════════════════════════════════════════════
 * 不做的话，用户在 Google 那边点了「取消」、或者邮箱对不上，
 * 回到我们这儿看到的是一个**什么都没发生的登录页** ——
 * 他会以为按钮坏了，然后一直点。错误码就在地址栏里，只是没人读它。
 *
 * 错误码的清单照 better-auth 的 `OAUTH_CALLBACK_ERROR_CODES`
 * （node_modules/better-auth/dist/oauth2/errors.mjs）和 OAuth 2.0 标准里
 * 授权方会回的那几个（`access_denied` 等）。认不出来的也不吞掉，原样带上错误码 ——
 * 用户截图来问的时候，那串码是唯一的线索。
 */
const MESSAGES: Record<string, string> = {
  /* OAuth 标准：在对方那边点了取消 / 不同意 */
  access_denied: '你在对方页面上取消了授权，什么都没改。想登录的话再点一次',
  /* better-auth 自己的 */
  account_not_linked:
    '这个邮箱在我们这儿已经有账号了，但还没法自动和这个第三方账号合并。'
    + '先用原来那种方式登录，再到「外观 › 登录方式」里点绑定',
  account_already_linked_to_different_user:
    '这个第三方账号已经绑在另一个账号上了。先登录那个账号把它解绑，或者换一个第三方账号',
  email_not_found: '对方没有给我们你的邮箱，所以登录不了。换一种方式登录',
  email_not_verified: '你在对方那边的邮箱还没验证过。先去验证一下，或者换一种方式登录',
  email_does_not_match: '第三方账号的邮箱和这个账号的对不上，绑定没成功',
  unable_to_link_account: '绑定没成功。再试一次，还不行就换一种方式',
  unable_to_get_user_info: '没能从对方那里拿到你的账号信息。稍后再试一次',
  invalid_code: '授权已经过期了，重新点一次',
  no_code: '授权没完成，重新点一次',
  please_restart_the_process: '授权过程被打断了，重新点一次',
  state_mismatch: '授权过程被打断了（可能开了两个窗口），重新点一次',
  oauth_provider_not_found: '服务器上还没配好这种登录方式',
  signup_disabled: '现在暂停了新用户用这种方式注册',
  internal_server_error: '服务器出了点问题，稍后再试一次'
};

/** 没有错误码就返回 null（大部分时候都是这样） */
export function describeOAuthError(code: string | null): string | null {
  if (code === null || code.trim() === '') return null;
  return MESSAGES[code] ?? `第三方登录没完成（错误码：${code}）。再试一次，或者换一种方式`;
}

/** 从地址里拿掉 `error` 和 `error_description`，剩下的原样留着（比如 `next`） */
export function stripOAuthError(search: string): string {
  const p = new URLSearchParams(search);
  p.delete('error');
  p.delete('error_description');
  const s = p.toString();
  return s === '' ? '' : '?' + s;
}
